// extracted by mini-css-extract-plugin
export default {"priceContainer":"Pga-z","discountedPrice":"Qga-z","originalPrice":"Rga-z","productPrice":"Sga-z"};